<template>
  <div class="home">
    <my-header activeNum="2" panoNum="1" userNum="1"></my-header>
    <div class="main">
      <div class="page">
        <div class="page-left">
          <div :class="{'page-left-li':true,'active':type=='1'}" @click="changeType(1)">全景图片</div>
          <div :class="{'page-left-li':true,'active':type=='2'}" @click="changeType(2)">全景视频</div>
          <!-- <div :class="{'page-left-li':true,'active':id=='3'}">模型</div> -->
          <!-- <div :class="{'page-left-li':true,'active':id=='4'}">图片</div>
          <div :class="{'page-left-li':true,'active':id=='5'}">视频</div>
          <div :class="{'page-left-li':true,'active':id=='6'}">音频</div>-->
          <div class="line"></div>
          <!-- <div class>
            <div class>
              <span>空间容量</span>
              <div class="">
                <svg width="16" height="16">
                  <g fill="#000" fill-rule="nonzero">
                    <path
                      d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 12.813A5.813 5.813 0 018 2.187a5.813 5.813 0 010 11.626z"
                    />
                    <path
                      d="M9.744 4.948A2.634 2.634 0 008 4.312c-.656 0-1.275.227-1.744.636-.487.427-.756 1-.756 1.614v.12c0 .068.056.124.125.124h.75a.125.125 0 00.125-.125v-.119c0-.689.673-1.25 1.5-1.25s1.5.561 1.5 1.25c0 .486-.344.932-.877 1.136a1.746 1.746 0 00-1.125 1.654v.335c0 .07.057.126.125.126h.75a.125.125 0 00.125-.126v-.354c0-.308.194-.59.483-.7.922-.355 1.517-1.167 1.517-2.07.002-.615-.267-1.188-.754-1.615zM7.375 11.438a.625.625 0 101.25 0 .625.625 0 00-1.25 0z"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div>0.00B / 3GB</div>
          </div>
          <div class="line"></div>-->
          <!-- <div class="word">
            <p>支持 2:1 图片上传</p>
            <p>2:1 最大支持 120MB 以内的全景图片</p>
          </div>-->
        </div>
        <div class="page-right">
          <div class="right-block">
            <div class="search-line">
              <el-input placeholder="请输入内容" v-model="searchTxt" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
              </el-input>
              <div class="btnBox">
                <el-button type="primary" @click="transferFolderClick" :disabled="fileArr.length==0">移动到</el-button>
                <el-button type="primary" @click="createFolder">新建文件夹</el-button>
              </div>
            </div>
            <div class="list-header">
              <div class="rootFolder" @click="backTop">
                根目录
              </div>
              <div v-show="nowFolderName!='根目录'">
                <span class="backFolder" @click="backFolder">返回上一级</span> <span>></span> <span v-html="nowFolderName"></span>
              </div>
            </div>
            <div class="list">
              <div class="list-li list-folder" v-for="(item) in folderArr" :key="item.id">
                <div class="imgBox" @click="changeFolder(item)">
                  <img src="data:image/png;base64,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">
                </div>
                <div class="middle">
                  <div class="li-title">
                    [<span>文件夹</span>]
                    <span class="li-title-span">{{item.name}}</span>
                  </div>
                  <div class="date">{{item.createTime | dateFormat('YY-mm-dd HH:MM')}}</div>
                </div>
                <div class="btns">
                  <div class="rename" @click="rename(item.id)">重命名</div>
                  <div class="del" @click="deleteFolder(item.id)">删除</div>
                </div>
              </div>
              <div class="list-li" v-for="(item) in arr" :key="item.id">
                <el-checkbox v-model="item.checked" @change="changeFileArr(item)"></el-checkbox>
                <div class="img-block">
                  <img :src="item.sceneCover" />
                </div>
                <div class="middle">
                  <div class="li-title">
                    [<span>风光</span>]
                    <span class="li-title-span">{{item.sceneName}}</span>
                  </div>
                  <div class="date">{{item.createTime | dateFormat('YY-mm-dd HH:MM')}}</div>
                </div>
                <div class="btns">
                  <router-link v-if="type==1" :to="'../panoedit/basic?id='+item.id" class="edit">编辑</router-link>
                  <router-link v-else :to="'../videoView?id='+item.id" class="edit">查看</router-link>
                  <div class="del" @click="downScene(item.id)">离线下载</div>
                  <div class="del" @click="transferTip = true; sceneID = item.id">迁移</div>
                  <div class="del" @click="del(item.id)">删除</div>
                </div>
              </div>
            </div>
            <div class="page-block">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page.currentPage"
                layout="total, prev, pager, next, jumper"
                :total="page.total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        title="迁移场景"
        :visible.sync="transferTip"
        width="400px">
        <el-form :model="transferForm">
          <el-form-item label="迁移手机" label-width="120px">
            <el-input v-model="transferForm.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认手机" label-width="120px">
            <el-input v-model="transferForm.rePhone" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="transferTip = false">取 消</el-button>
          <el-button type="primary" @click="transferFun">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="移动到文件夹"
        :visible.sync="transferFolder"
        width="800px"
        >
         <div class="list-header">
              <div class="rootFolder" @click="backTopIn">
                根目录
              </div>
              <div v-show="nowFolderNameInner!='根目录'">
                <span class="backFolder" @click="backREInner()">返回上一级</span> <span>></span> <span v-html="nowFolderNameInner"></span>
              </div>
            </div>
             <div class="listIn">
              <div class="list-li list-folder" v-for="(item) in folderArrInner" :key="item.id">
                <div class="imgBox" @click="changeFolderInner(item)">
                  <img src="data:image/png;base64,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">
                </div>
                <div class="middle">
                  <div class="li-title">
                    [<span>文件夹</span>]
                    <span class="li-title-span">{{item.name}}</span>
                  </div>
                  <div class="date">{{item.createTime | dateFormat('YY-mm-dd HH:MM')}}</div>
                </div>
              </div>
             </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="transferFolderFun">移动到{{nowFolderNameInner}}</el-button>
        </span>
      </el-dialog>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<style scoped>
.home {
  height: auto;
  min-width: 1180px;
  background-color: #f8f8f8;
}
.main {
  position: relative;
  margin: 20px auto;
  width: 1180px;
  min-height: calc(100vh - 130px);
}

.page {
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 130px);
}

.page-left {
  position: relative;
  width: 210px;
}

.page-left-li {
  height: 40px;
  padding-left: 20px;
  line-height: 40px;
  color: rgb(95, 95, 95);
  cursor: pointer;
  background-color: transparent;
  border-radius: 5px;
}

.page-left-li.active {
  color: rgb(255, 255, 255);
  background-color: rgb(40, 110, 250);
}
.line {
  height: 1px;
  background-color: rgb(222, 222, 222);
  margin-top: 20px;
  margin-bottom: 20px;
}
.word {
  font-size: 12px;
  color: rgb(122, 122, 122);
  line-height: 17px;
}

.page-right {
  position: relative;
  width: 950px;
  min-height: calc(100vh - 130px);
  background-color: white;
}

.right-block {
  display: flex;
  /* position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0; */
  padding: 20px 20px 10px;
  flex-flow: column nowrap;
}

.search-line {
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.input-with-select {
  width: 180px;
}

.list-header {
  height: 50px;
  width: 100%;
  background-color: #f8f8f8;
  display: flex;
}
.list-header div{
  height: 50px;
  line-height: 50px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.list-header .rootFolder:hover{
  color: #286efa;
}
.list-header .backFolder:hover{
  color: #286efa;
}
.list {
  /* height: 720px; */

}

.list-li {
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #e9e9e9;
}
.list-li .el-checkbox{
  margin-right: 10px;
}
.middle {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  height: 40px;
  margin-left: 10px;
  line-height: 1.4286;
  flex-flow: column nowrap;
  flex: 1 1 auto;
}

.img-block {
  width: 40px;
  height: 40px;
  background-color: #ddd;
  cursor: pointer;
}
.imgBox{
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.imgBox img{
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.img-block img {
  width: 100%;
  height: 100%;
}
.list-folder .imgBox{
  margin-left: 24px;
}
.listIn .list-folder .imgBox{
  margin-left: 0;
}
.li-title {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}

.date {
  font-size: 12px;
  color: #9b9b9b;
}

.li-title-span {
  display: inline-block;
  max-width: 350px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-wrap: normal;
  cursor: pointer;
  margin-left: 15px;
  overflow: hidden;
}

.page-block {
  display: flex;
  justify-content: center;
}

.btns {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.rename {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  color: #286efa;
  font-size: 12px;
  line-height: 24px;
  text-decoration: none;
}
.edit {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  color: #286efa;
  font-size: 12px;
  line-height: 24px;
  text-decoration: none;
}

.del {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  color: #286efa;
  font-size: 12px;
  line-height: 24px;
}
</style>
<script>
import https from '../https.js'
import MyHeader from '../components/header.vue'
import MyFooter from '../components/footer.vue'
export default {
  name: '',
  components: {
    MyHeader: MyHeader,
    MyFooter: MyFooter
  },
  data() {
    return {
      nowFolderNameInner: '根目录',
      transferFolder: false,
      hasChooseFile: true,
      folderArr: [],
      type: 1,
      searchTxt: '',
      page: {
        currentPage: 1,
        total: 0
      },
      arr: [],
      transferTip: false,
      sceneID: '',
      transferForm: {
        phone: '',
        rePhone: ''
      },
      nowFolderName: '根目录',
      nowFolderID: '',
      nowFolderPName: '',
      nowFolderPID: '',
      fileArr: [],
      folderCurrentPage: 1,
      folderArrInner: [],
      nowFolderIDInner: '',
      nowFolderPIDInner: '',
      nowFolderPNameInner: '',
      folderPage: {
        currentPage: 1,
        total: 0
      }
    }
  },
  created() {},
  mounted() {
    const t = this.$route.query.type || 1
    this.type = t
    this.init()
    https
      .fetchGet('/api/folder/Get', {
        folderType: parseInt(this.type),
        pageIndex: this.folderPage.currentPage,
        pageSize: 10,
        id: this.nowFolderIDInner
      })
      .then(res => {
        console.log(res.data)
        this.folderPage.total = res.data.count
        this.folderArrInner = res.data.result
      })
  },
  methods: {
    backTopIn() {
      this.nowFolderNameInner = '根目录'
      this.nowFolderIDInner = ''
      this.nowFolderPNameInner = ''
      this.nowFolderPIDInner = ''
      https
        .fetchGet('/api/folder/Get', {
          folderType: this.genFolderType(),
          pageIndex: this.folderPage.currentPage,
          pageSize: 10,
          id: this.nowFolderIDInner
        })
        .then(res => {
          console.log(res.data)
          this.folderPage.total = res.data.count
          this.folderArrInner = res.data.result
          this.transferFolder = true
        })
    },
    backTop() {
      this.nowFolderName = '根目录'
      this.nowFolderID = ''
      this.init()
    },
    backFolder() {
      if(this.nowFolderPID == null) {
        this.nowFolderID = ''
        this.nowFolderName = '根目录'
        this.init()
      }else{
        https
          .fetchGet('/api/folder/Get', {
            FID: this.nowFolderPID
          })
          .then(res => {
            console.log(res.data)
            this.nowFolderName = res.data.result[0].name
            this.nowFolderID = res.data.result[0].id
            this.nowFolderPID = res.data.result[0].parentID
            this.init()
          })
      }
    },
    backREInner() {
      if(this.nowFolderPIDInner == null) {
        this.nowFolderIDInner = ''
        this.nowFolderNameInner = '根目录'
        https
          .fetchGet('/api/folder/Get', {
            folderType: parseInt(this.type),
            pageIndex: this.folderPage.currentPage,
            pageSize: 10,
            id: this.nowFolderPIDInner
          })
          .then(res => {
            console.log(res.data)
            this.folderPage.total = res.data.count
            this.folderArrInner = res.data.result
            this.transferFolder = true
          })
      }else{
        https
          .fetchGet('/api/folder/Get', {
            FID: this.nowFolderPIDInner
          })
          .then(res => {
            console.log(res.data)
            this.nowFolderNameInner = res.data.result[0].name
            this.nowFolderIDInner = res.data.result[0].id
            this.nowFolderPIDInner = res.data.result[0].parentID
            https
              .fetchGet('/api/folder/Get', {
                folderType: parseInt(this.type),
                pageIndex: this.folderPage.currentPage,
                pageSize: 10,
                id: this.nowFolderIDInner
              })
              .then(res => {
                console.log(res.data)
                this.folderPage.total = res.data.count
                this.folderArrInner = res.data.result
                this.transferFolder = true
              })
          })
      }
    },
    transferFolderClick() {
      this.nowFolderIDInner = ''
      this.nowFolderNameInner = '根目录'
      https
        .fetchGet('/api/folder/Get', {
          folderType: parseInt(this.type),
          pageIndex: this.folderPage.currentPage,
          pageSize: 10,
          id: this.nowFolderIDInner
        })
        .then(res => {
          console.log(res.data)
          this.folderPage.total = res.data.count
          this.folderArrInner = res.data.result
          this.transferFolder = true
        })
    },
    handleClose() {
    },
    changeFolderInner(item) {
      this.nowFolderPNameInner = this.nowFolderNameInner
      this.nowFolderIDInner = item.id
      this.nowFolderNameInner = item.name
      this.nowFolderPIDInner = item.parentID
      https
        .fetchGet('/api/folder/Get', {
          folderType: parseInt(this.type),
          pageIndex: this.folderPage.currentPage,
          pageSize: 10,
          id: this.nowFolderIDInner
        })
        .then(res => {
          console.log(res.data)
          this.folderPage.total = res.data.count
          this.folderArrInner = res.data.result
        })
    },
    changeFolder(item) {
      this.nowFolderPName = this.nowFolderName
      this.nowFolderID = item.id
      this.nowFolderName = item.name
      this.nowFolderPID = item.parentID
      this.init()
    },
    transferFolderFun() {
      https
        .fetchGet('/api/folder/MoveToFolder', {
          sceneID: this.fileArr.join(','),
          folderID: this.nowFolderIDInner === '' ? '00000000-0000-0000-0000-000000000000' : this.nowFolderIDInner
        })
        .then(res => {
          console.log(res.data)
          if(res.data.code === 1) {
            this.$message({
              type: 'info',
              message: '移动成功'
            })
          }else{
            this.$message({
              type: 'info',
              message: '移动失败'
            })
          }
          this.fileArr = []
          this.transferFolder = false
          this.init()
        })
    },
    changeFileArr(mJson) {
      if(mJson.checked) {
        this.fileArr.push(mJson.id)
      }else{
        var index = this.fileArr.indexOf(mJson.id)
        if (index > -1) {
          this.fileArr.splice(index, 1)
        }
      }
    },
    rename(id) {
      this.$prompt('请输入文件夹名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        https.fetchPost('/api/folder/Edit', {
          id: id,
          name: value,
          parentID: this.nowFolderID,
          type: 1 //1：全景图片作品 2：全景视频品 3:全景图片素材 4：全景视频素材 5：图片素材 6：模型素材 7：视频素材 8：音频素材
        })
          .then(res => {
            console.log(res)
            this.init()
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    deleteFolder(id) {
      this.$confirm('确定删除文件内所有内容，本操作无法恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        https.fetchPost('/api/folder/Edit', {
          id: id,
          status: 0
        })
          .then(res => {
            console.log(res)
            this.$message({
              type: 'info',
              message: '删除成功'
            })
            this.init()
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    createFolder() {
      this.$prompt('请输入文件夹名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        // this.$message({
        //   type: 'success',
        //   message: '文件夹名称是: ' + value
        // })
        https.fetchPost('/api/folder/Edit', {
          name: value,
          parentID: this.nowFolderID,
          folderType: parseInt(this.type) //1：全景图片作品 2：全景视频品 3:全景图片素材 4：全景视频素材 5：图片素材 6：模型素材 7：视频素材 8：音频素材
        })
          .then(res => {
            console.log(res)
            this.init()
            // if(res.status == 200 && res.statusText == 'OK') {
            //   this.$message({
            //     message: '迁移成功',
            //     type: 'success'
            //   })
            //   this.transferTip = false
            //   this.init()
            // }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    isPhoneTel(n) {
      var reg = /^1[3|4|5|8]\d{9}$/
      if(reg.test(n)) {
        return true
      } else{
        return false
      }
    },
    transferFun() {
      if(this.transferForm.phone !== '' && this.transferForm.rePhone !== '') {
        if(this.isPhoneTel(this.transferForm.phone) && this.isPhoneTel(this.transferForm.rePhone)) {
          if(this.transferForm.phone !== this.transferForm.rePhone) {
            this.$message({
              message: '两次输入手机号码不一致',
              type: 'warning'
            })
          }else{
            https
              .fetchGet('/api/Scene/TransferScene', {
                sceneID: this.sceneID,
                desPhone: this.transferForm.phone
              })
              .then(res => {
                console.log(res)
                if(res.status == 200 && res.statusText == 'OK') {
                  this.$message({
                    message: '迁移成功',
                    type: 'success'
                  })
                  this.transferTip = false
                  this.init()
                }
              })
          }
        }else{
          this.$message({
            message: '请输入正确的手机号码',
            type: 'warning'
          })
        }
      }else{
        this.$message({
          message: '输入框不能为空',
          type: 'warning'
        })
      }
    },
    downScene(id) {
      https
        .fetchPost('/api/HotPoint/OfflineModelDownload', {
          sceneID: id
        })
        .then(res => {
          console.log(res)
          var link = document.createElement('a')
          link.style.display = 'none'
          document.body.appendChild(link)
          link.href = 'https://720.z2ww.com/' + res.data
          // link.download = '1_f'
          link.click()
        })
    },
    init() {
      https
        .fetchPost('/api/Scene/Get', {
          sceneName: this.searchTxt,
          type: this.type,
          folderType: parseInt(this.type),
          pageIndex: this.page.currentPage,
          pageSize: 10,
          folderID: this.nowFolderID
        })
        .then(res => {
          console.log(res.data)
          this.page.total = res.data.count
          this.arr = res.data.result
          this.folderArr = res.data.folders
        })
    },
    search() {
      this.page.currentPage = 1
      this.init()
    },
    changeType(num) {
      this.type = num
      this.page.currentPage = 1
      this.nowFolderNameInner = '根目录'
      this.nowFolderIDInner = ''
      this.nowFolderPNameInner = ''
      this.nowFolderPIDInner = ''
      this.nowFolderName = '根目录'
      this.nowFolderPID = ''
      this.nowFolderPName = ''
      this.nowFolderID = ''
      this.chooseArr = []
      this.fileArr = []
      this.init()
      this.$router.push('../my/product?type=' + this.type)
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.init()
    },
    del(id) {
      this.$confirm('此操作将永久删除该场景, 是否继续?', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      })
        .then(() => {
          https
            .fetchPost('/api/Scene/Edit', {
              id: id,
              status: 0
            })
            .then(res => {
              console.log(res.data)
              this.$message({
                showClose: true,
                type: 'success',
                message: '删除成功!'
              })
              this.init()
            })
        })
        .catch(() => {})
    }
  }
}
</script>
